window.dyUtils = {
  waitFor: (cond, callback, interval, attempts, count) => {
    attempts = attempts || false;
    count = count || 0;
    if (cond()) {
      callback();
    } else if (count <= attempts || !attempts) {
      count += 1;
      setTimeout(() => {
        window.dyUtils.waitFor(cond, callback, interval, attempts, count);
      }, interval);
    }
  },
  onElementLoaded: (selector, callback) => {
    if (document.querySelector(selector)) {
      callback();
      return;
    }
    window.dyUtils.waitFor(() => document.querySelector(selector), callback, 500);
  },
  onPdpLoaded: (callback) => window.dyUtils.onElementLoaded('.product-details .product-info.loaded', callback),
  onPlpLoaded: (callback) => window.dyUtils.onElementLoaded('.blm-products-list .product-card', callback),
};

function DyProductBadges() {
  this.isPlp = false;
  this.showOnIncluded = false;
  this.showOnExcluded = false;
  this.plpSelector = '.blm-products-list';
  this.pdpSelector = '.product-details .product-info';
  this.plpTargetSelector = '.blm-products-list .product-image';
  this.pdpTargetSelector = '.product-details .product-title-wrapper';
  this.priority = '1';
  this.recommendationId = '';
  this.widgetId = '';
  this.skus = '';

  this.init = function () {
    this.isPlp = !!document.querySelector(this.plpSelector);
    this.skus = this.skus ? this.skus.split(',').map((sku) => sku.trim()) : [];

    if (this.isPlp) {
      if(document.querySelector('.pagination-load-more button')!=null) {
        document.querySelector('.pagination-load-more button')
          .addEventListener('click', () => {
            setTimeout(() => {
              this.createElements();
            }, 1000);
        });
      }
    }

    if (this.skus.length) {
      this.createElements();
      return;
    }

    this.loadProducts().then((items) => {
      this.skus = items;
      this.createElements();
    });
  };
  this.loadProducts = function () {
    return new Promise((resolve, reject) => {
      DYO.recommendationWidgetData(this.recommendationId, {maxProducts: 10000}, (err, data) => {
        if (err) {
          reject(false);
          return;
        }
        if (data.slots.length) {
          resolve(data.slots.map((slot) => slot.product.item.sku));
        }
      });
    });
  };
  this.attachToProduct = function (product) {
    if (this.skus.includes(product.dataset.sku) && this.showOnIncluded) {
      this.createElement(product, true);
    } else if (this.showOnExcluded) {
      this.createElement(product, false);
    }
  };
  this.getTemplate = function (isIncluded) {
    const embed = document.querySelectorAll('[data-dy-embedded-object=true]');

    let template = null;
    for (let object of embed) {
      if (!object.shadowRoot) {
        continue;
      }
      template = object.shadowRoot.querySelector(
        '.dy_badge_html-' + this.widgetId + '--container .dy_badge_html-' + this.widgetId +
        (isIncluded ? '.included' : '.excluded'),
      );
      if (template) {
        break;
      }
    }
    return template ? template.cloneNode(true) : null;
  };
  this.createElements = function () {
    if (this.isPlp) {
      const products = document.querySelectorAll(this.plpSelector + ' .product-card');
      products.forEach((product) => {
        if (!product.querySelector('.product-image')) {
          return;
        }

        this.attachToProduct(product);
      });
      return;
    }

    if (DY.recommendationContext.type === 'PRODUCT') {
      const product = document.querySelector(this.pdpSelector);
      this.attachToProduct(product);
    }
  };
  this.createElement = function (product, isIncluded) {
    if (product.classList.contains('dy_badge_applied')) {
      if (this.priority >= product.dy_badge_priority) {
        return;
      }
      product.querySelector('[class^="dy_badge_html-"]').remove();
    }

    const badge = this.getTemplate(isIncluded);
    if (!badge) {
      return;
    }
    let selector = this.pdpTargetSelector;
    if (this.isPlp) {
      selector = this.plpTargetSelector;
      product.querySelector(selector).after(badge);
    }

    if (DY.recommendationContext.type === 'PRODUCT') {
      document.querySelector(selector).after(badge);
    }

    product.classList.add('dy_badge_applied');
    product.dy_badge_priority = this.priority;
  };
}

function DyProductsCarousel() {
  this.widgetId = '';
  this.container = '.upsell-carousel';
  this.showPrice = true;
  this.numberOfItems = 12;
  this.strategyId = '';

  this.arrows = 1;
  this.dots = 0;
  this.infiniteScroll = 1;
  this.autoplay = 0;
  this.autoplaySpeed = 3;
  this.slidesToShow = 5;
  this.slidesToScroll = 1;

  this.standardSlidesToShow = 4;
  this.standardSlidesToScroll = 1;

  this.tabletSlidesToShow = 3;
  this.tabletSlidesToScroll = 1;
  this.tabletArrows = 1;
  this.tabletDots = 0;

  this.mobileSlidesToShow = 2;
  this.mobileSlidesToScroll = 1;
  this.mobileArrows = 0;
  this.mobileDots = 0;

  this.init = function () {
    const root = document.querySelector(this.container).shadowRoot
    const slider = root.querySelector('.sliding_recs_' + this.widgetId);

    const navigation = {
      nextEl: root.querySelector('.swiper-button-next-' + this.widgetId),
      prevEl: root.querySelector('.swiper-button-prev-' + this.widgetId),
    }
    const pagination = {
      el: root.querySelector('.swiper-pagination-' + this.widgetId),
      clickable: true,
    }

    this.addSwiper().then(() => {
      const settings = {
        slidesPerView: 1,
        slidesPerGroup: parseInt(this.mobileSlidesToScroll) || parseInt(this.slidesToShow),
        navigation: !!parseInt(this.mobileArrows) ? navigation : false,
        pagination: !!parseInt(this.mobileDots) ? pagination : false,

        spaceBetween: 10,
        pauseOnMouseEnter: true,
        autoplay: !!parseInt(this.autoplay) ? {
          delay: parseInt(this.autoplaySpeed) * 1000,
        } : false,
        loop: !!parseInt(this.infiniteScroll),
        breakpoints: {
          414: {
            slidesPerView: parseInt(this.tabletSlidesToShow) || parseInt(this.slidesToShow),
            slidesPerGroup: parseInt(this.tabletSlidesToScroll) || parseInt(this.slidesToShow),
            navigation: !!parseInt(this.tabletArrows) ? navigation : false,
            pagination: !!parseInt(this.tabletDots) ? pagination : false,
          },
          769: {
            slidesPerView: parseInt(this.standardSlidesToShow) || parseInt(this.slidesToShow),
            slidesPerGroup: parseInt(this.standardSlidesToScroll) || parseInt(this.standardSlidesToScroll),
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: parseInt(this.slidesToShow) || 5,
            slidesPerGroup: parseInt(this.slidesToScroll) || 1,
            navigation: !!parseInt(this.arrows) ? navigation : false,
            pagination: !!parseInt(this.dots) ? pagination : false,
          },
        },
      };

      if (!parseInt(this.showPrice)) {
        slider.classList.add('hide-price');
      }

      new Swiper(slider.querySelector('.swiper'), settings)
      slider.classList.remove('dy-no-show');
    });
  }

  this.addSwiper = function () {
    return new Promise((resolve) => {
      const shadowRoot = document.querySelector(this.container).shadowRoot;
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.setAttribute('href', '//unpkg.com/swiper/swiper-bundle.min.css');
      shadowRoot.appendChild(style);

      if (window.Swiper) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      document.querySelector('head').appendChild(script);
      script.onload = () => {
        resolve()
      }
      script.setAttribute('src', '//unpkg.com/swiper/swiper-bundle.min.js');
    });
  }

  this.downloadProducts = function (realtimeRules) {
    return new Promise((resolve) => {
      DYO.recommendations.getRcomData(
        this.strategyId,
        {
          maxProducts: this.numberOfItems,
          realtimeRules,
        },
        (err, data) => {
          if (!data) {
            return;
          }

          this.createMarkup(data);
          resolve();
      });
    })
  }

  this.createMarkup = function (data) {
    const root = document.querySelector(this.container).shadowRoot;
    const slider = root.querySelector('.sliding_recs_' + this.widgetId);
    const sliderWrapper = slider.querySelector('.swiper-wrapper');
    const template = slider.querySelector('#swiper-slide')

    const products = data.strategies[0].items;
    if (!products.length) {
      document.querySelector(this.container).style.display = 'none';
      return;
    }

    slider.setAttribute('data-dy-widget-id', data.wId);
    slider.setAttribute('data-dy-feed-id', data.fId);

    products.forEach((product) => {
      const clone = template.content.cloneNode(true);

      clone.querySelector('a').href = product.url;
      clone.querySelector('.rec_name').textContent = product.name;
      clone.querySelector('.rec_price').textContent = '$' + product.price;

      const img = clone.querySelector('img');
      img.src = product.image_url;
      img.alt = product.name;

      const item = clone.querySelector('.rec-item-wrap');
      item.setAttribute('data-dy-product-id', product.sku);
      item.setAttribute('data-dy-strategy-id', this.strategyId);

      sliderWrapper.appendChild(clone);
    })

    template.remove()
    DYO.recommendations.registerElements(slider);
  }
}
